<template lang="html">
  <v-select
    :class="{small: appSmall}"
    class="test-type-selector"
    placeholder="Select Test Type"
    :items="items"
    @change="$emit('input', $event)"
    :light="light"
    :dark="dark"
    hide-details
    :value="value"
  />
</template>

<style lang="scss">
.test-type-selector {
  .v-select__selection {
    max-width: 20vw;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>

<script>
import TestTypes from '@/lib/TestTypes'

export default {
  props: {
    value: {
      default: null
    },
    light: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    items () {
      return TestTypes.map(t => ({ text: t.name, value: t.id }))
    }
  }
}
</script>
